import OrderItem from "./OrderItem";
import { Grid } from "@mui/material";
import styled from "styled-components";
import { fetchOrderAF, repurchaseByOrderId } from "../../../apis";
import { useNavigate } from "react-router-dom";
import { appearGlobalError } from "../../../requests/globalRequest";
import { useTranslation } from "react-i18next";
import { GetWord } from "../../../utils/common";
import EmptyOrderHistory from "./EmptyOrderHistory";
import { breakpoint } from "../../../utils/responsive";

const OrderContainer = styled.div`
    display: flex;
    flex-direction: column;
    gap: 35px;
    width: 100%;

    @media ${breakpoint.mobile} {
        padding: 0 30px;
    }
`

const OrderInfo = (props) => {
    const { data=[] } = props;

    const { t } = useTranslation(['profile', 'common']);

    const navigate = useNavigate();

    const handlePayAgain = async (orderId) => {
        // console.log('==onClick pay again button', orderId)
        const res = await repurchaseByOrderId({ orderId: orderId })
        // console.log('==payAgain res', res)
        if (res && res?.msg === 'success') {
            if (res?.cartErrors && res.cartErrors.length > 0) {
                const errorMessage = res?.cartErrors?.map((item) => GetWord(item?.errorMessage)).join(', ')
                props?.globalDispatch && appearGlobalError(
                    props.globalDispatch,
                    t('common:theFollowingCannotAddToCart'),
                    errorMessage,
                    { type: "fail" },
                )
            }
            if (res?.data?.items && res.data?.items.length > 0) return navigate("/shoppingcart")
        } else {
            props?.globalDispatch && appearGlobalError(
                props.globalDispatch,
                res?.result?.code, 
				res?.result?.errorMessage, 
				{ type: "fail" },
            )
        }
    }

    const handleDownloadOrderAF = async (orderId) => {
        try {
            const res = await fetchOrderAF(orderId);
            if (res) {
                const blob = new Blob([res], { type: 'application/pdf' });
                const linkSource = window.URL.createObjectURL(blob);
                const downloadLink = document.createElement("a");
                const fileName = `order-${orderId}.pdf`;
                downloadLink.href = linkSource;
                downloadLink.download = fileName;
                downloadLink.click();
            } else {
                throw new Error('fetch order pdf failed')
            }
        } catch (err) {
            props?.globalDispatch && appearGlobalError(
                props.globalDispatch,
                err?.result?.code,
                err?.result?.errorMessage,
                { type: "fail" },
            )
        }
    }

    if (data.length === 0) return (
        <EmptyOrderHistory />
    )
    else return (
        <OrderContainer>
            { [...data].reverse().map((item, index) => {
                const finalOrderIndex = data.length - index;
                return (
                    <div>
                        <OrderItem
                            key={`myOrder-${finalOrderIndex}`}
                            data={item}
                            index={finalOrderIndex}
                            defaultExpand={index === 0}
                            onClickPayAgain={handlePayAgain}
                            onClickDownloadAF={handleDownloadOrderAF}
                        />
                    </div>
                )
            })}
        </OrderContainer>
    )
}

export default OrderInfo;